/**
 * 회원 화면으로 가는 **하나뿐인 경로 정의** (2026-09-02).
 *
 * ─────────────────────────────────────────────────────────────
 * 🔴 왜 상수로 뽑았나 — 실사용에서 터진 일
 * ─────────────────────────────────────────────────────────────
 * 오늘의 시그널 카드의 「수강권 등록」이 **구 화면**으로 가고 있었다.
 * `/member/detail`(`MemberProfilePage`)은 라우터에 살아 있었지만 아무도
 * 안 쓰는 옛 화면이었고, 지금 원장들이 쓰는 것은 `/member/:memberId`
 * (`PublicMemberDetailPage` · 「통합 회원 상세」)다.
 *
 * 라우터 정의만 보면 둘 다 실재해서 구별이 안 된다. **호출부를 따라가야**
 * 어느 쪽이 현행인지 알 수 있는데, 그건 다음 사람도 똑같이 놓친다.
 *
 * 그래서 **회원 목록의 행 클릭과 같은 함수를 쓰게** 만든다. 회원 목록은
 * 원장이 매일 누르는 자리라 그게 죽으면 즉시 드러난다 — 거기와 같은 것을
 * 쓰는 한 이 링크도 같이 살아 있다.
 *
 * ⚠️ 경로를 옮길 일이 생기면 **여기만** 고친다. 문자열을 다시 흩뿌리면
 *    같은 사고가 반복된다.
 */

/**
 * 회원 상세(통합) — 현행 화면.
 *
 * `PublicMemberDetailPage` 가 `useParams` 로 읽으므로 **URL 경로 파라미터가
 * 본체**다. `state` 는 회원 목록이 함께 넘기는 것과 맞춰 둔 것이고, 화면이
 * 없어도 도는 값이라 링크가 URL 하나로도 성립한다(북마크·새로고침 안전).
 */
export const memberDetailPath = (memberId: string): string => `/member/${memberId}`;

/** 회원 목록·시그널 카드가 함께 넘기는 라우터 state — 두 곳이 같아야 한다 */
export const memberDetailState = (memberId: string): { memberId: string } => ({ memberId });
